<div class="error-notification-area">
  <p>
    <span *ngFor="let d of data">{{d.error}}</span>
  </p>
  <button mat-button mat-raised-button color="accent"(click)="snackBarRef.dismiss()">OK</button>
</div>